import { TabList as ChakraTabList } from '@chakra-ui/react'

import { TabListProps } from './TabList.types'

export default function TabList(props: TabListProps) {
  return <ChakraTabList {...props} translate="no" />
}
